<template>
  <a
    v-if="button"
    class="CardButton"
    :class="button.class"
    :style="button.style"
    :href="button.url">
    {{ button.text | translate }}
  </a>
</template>

<script>
export default {
  name: 'card-button',
  props: {
    button: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
</style>
